/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_EditInputs */

const en_shared_edit = /** @type {(inputs: Shared_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const nl_shared_edit = /** @type {(inputs: Shared_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerken`)
};

/** @type {(inputs: Shared_EditInputs) => LocalizedString} */
const de_shared_edit = en_shared_edit;

/** @type {(inputs: Shared_EditInputs) => LocalizedString} */
const es_shared_edit = en_shared_edit;

/** @type {(inputs: Shared_EditInputs) => LocalizedString} */
const fr_shared_edit = en_shared_edit;

/** @type {(inputs: Shared_EditInputs) => LocalizedString} */
const it_shared_edit = en_shared_edit;

/** @type {(inputs: Shared_EditInputs) => LocalizedString} */
const pt_br2_shared_edit = en_shared_edit;

/** @type {(inputs: Shared_EditInputs) => LocalizedString} */
const pl_shared_edit = en_shared_edit;

/** @type {(inputs: Shared_EditInputs) => LocalizedString} */
const hu_shared_edit = en_shared_edit;

/** @type {(inputs: Shared_EditInputs) => LocalizedString} */
const ro_shared_edit = en_shared_edit;

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Shared_EditInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_edit = /** @type {((inputs?: Shared_EditInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_EditInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_edit(inputs)
	if (locale === "de") return de_shared_edit(inputs)
	if (locale === "es") return es_shared_edit(inputs)
	if (locale === "fr") return fr_shared_edit(inputs)
	if (locale === "nl") return nl_shared_edit(inputs)
	if (locale === "it") return it_shared_edit(inputs)
	if (locale === "pt-BR") return pt_br2_shared_edit(inputs)
	if (locale === "pl") return pl_shared_edit(inputs)
	if (locale === "hu") return hu_shared_edit(inputs)
	return ro_shared_edit(inputs)
});
export { shared_edit as "shared.edit" }